import '../../resources/css/settings/FloorSettingsList.scss';
import 'react-tabulator/lib/styles.css';
import "react-tabulator/lib/css/bootstrap/tabulator_bootstrap4.min.css";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { listDateFormatter } from '../common/access-list';
import { ReactTabulator } from 'react-tabulator';
import DateFilter from './DateFilter';
import {
  doConfirmAccountApply,
  DELETE_SETTING_ACCOUNT_SUCCESS,
  DELETE_SETTING_ACCOUNT_FAIL,
  SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS,
  CONFIRM_SETTING_ACCOUNT_APPLY_SUCCESS,
  loadFloorPlanSettingList,
  SAVE_SETTING_ROLE_DETAIL_SUCCESS,
  saveAccountOperationStatus, saveAccountOperationStatusInFrontEnd
} from '../../actions/settings/index';
import { popupModalConfirm, openModal, openPickModal, MODAL_PICK_SAVE, openModalAlert } from '../../actions/index';
import ListColumnBtn from '../common/ListColumnBtn';

let orgFilter;


class FloorPlanSettingsList extends Component {
    tableId = 'FloorPlanSettingsList'
    
    state = {
      refTable: null,
      isInitComplete: false, 
      sessionKey: window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT['manager'],
      pageSize: 10,
      pageSizeList: [10, 20, 30, 40],
      dateFilter: {
        from: null,
        to: null,
        column: null
      },
      visibleColumnsConfig : {
        columns: [
          { title: "ID", field: "id" },
          { title: "Floor Name", field: "floorName" },
          { title: "Environment", field: "environment" },
          { title: "Project Name", field: "projectName" },
          { title: "Site Name", field: "siteName" },
          { title: "Create Date", field: "createdDate" },
          { title: "Created By", field: "createdBy" },
          { title: "Last Updated Date", field: "lastUpdatedDate" },
          { title: "Last Updated By", field: "lastUpdatedBy" },
          { title: "Width", field: "width" },
          { title: "Height", field: "height" },  
          { title: "Description", field: "description" },
          { title: "File Name", field: "fileName" },
          { title: "Scale", field: "scale" },
          { title: "Scale Line", field: "scaleLine" },
          { title: "Advanced Channel Recommendation", field: "advancedChannelRecommendation"},
          { title: "Channel Recommendation Enabled", field: "channelRecommendationEnabled" },
          { title: "2.4GHz Channels", field: "band24GHzChannels"},
          { title: "5GHz1 Channels", field: "band5GHz1Channels"},
          { title: "5GHz2 Channels", field: "band5GHz2Channels"},
          { title: "6GHz Channels", field: "band6GHzChannels"},
          { title: "buttonGroup", field: "buttonGroup", visible: false }
        ]
      },
    }  
  
    readyToAdd = (e) => {
      const { openPickModal } = this.props;
      openPickModal("settingsAccountReadyAdd", null);
    }
  
    addRow = () => {
      const { doSelectAccount, openModal } = this.props;
      openModal("settingsAccount", 'add', null, () => doSelectAccount(null));
    }
  
    dataLoading = (datas) => {
      if (this.ref && !this.state.isInitComplete) {
        this.setState({
          isInitComplete: true,
          refTable: this.ref.table
        });
      }
    }
  
    dateFormatterParams = {
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      timezone: this.props.timeZoneID
    };
  
    columns = [
      { title: "ID", field: "id" },
      { title: "Floor Name", field: "floorName" },
      { title: "Environment", field: "environment" },
      { title: "Project Name", field: "projectName" },
      { title: "Site Name", field: "siteName" },
      { title: "Create Date", field: "createdDate", formatter: listDateFormatter, formatterParams: this.dateFormatterParams },
      { title: "Created By", field: "createdBy" },
      { title: "Last Updated Date", field: "lastUpdatedDate", formatter: listDateFormatter, formatterParams: this.dateFormatterParams },
      { title: "Last Updated By", field: "lastUpdatedBy" },
      { title: "Description", field: "description", visible: false },
      { title: "Width", field: "width", visible: false },
      { title: "Height", field: "height", visible: false },
      { title: "File Name", field: "fileName", visible: false },
      { title: "Scale", field: "scale", visible: false },
      { title: "Scale Line", field: "scaleLine", visible: false },
      { title: "Advanced Channel Recommendation", field: "advancedChannelRecommendation", visible: false },
      { title: "Channel Recommendation Enabled", field: "channelRecommendationEnabled", visible: false },
      { title: "2.4GHz Channels", field: "band24GHzChannels", visible: false },
      { title: "5GHz1 Channels", field: "band5GHz1Channels", visible: false },
      { title: "5GHz2 Channels", field: "band5GHz2Channels", visible: false },
      { title: "6GHz Channels", field: "band6GHzChannels", visible: false },
    ];
  
    handleDateFilter = ({ from, to, column }) => {
      this.setState({ 
        dateFilter: { from, to, column }
      }, () => {
        if (this.state.refTable) {
          this.state.refTable.setFilter(this.filterByDate);
        }
      });
    }
  
    filterByDate = (data) => {
      const { dateFilter } = this.state;
      if (!dateFilter.from || !dateFilter.to || !dateFilter.column) return true;
  
      const dateValue = data[dateFilter.column];
      if (!dateValue) return false;
  
      const rowDate = new Date(dateValue);
      const fromDate = new Date(dateFilter.from);
      const toDate = new Date(dateFilter.to);
      toDate.setHours(23, 59, 59, 999); // Include the entire end day
  
      return rowDate >= fromDate && rowDate <= toDate;
    }
  
    renderTable = () => {
      const { tabulatorDivHeight, authToken, loadFloorPlanSettingList } = this.props;
      const {pageSize, pageSizeList} = this.state;
  
      const options = {
        height: tabulatorDivHeight,
        maxHeight: "calc(100vh - 250px)",
        //ajaxURL: "http://localhost:8080/api/visual/get-all",
        ajaxURL: window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER["visual"] + "/get-all",
        pagination: "local",
        paginationSize: pageSize ? pageSize : 10, 
        paginationSizeSelector: pageSizeList,
        layout: "fitColumns",
  
        ajaxConfig: {
          method: 'POST',
          mode: 'cors'
        },
        ajaxContentType: {
          headers: {
            'Authorization': authToken,
            'Content-Type': 'application/json',
          },
          body: function (url, config, params) {
            return JSON.stringify({
              organizationId: orgFilter,
              offset: 0
            });
          },
        },
  
        ajaxResponse: (url, params, response) => {
          console.log("Floor plans loaded:", response);
          try {
            if (loadFloorPlanSettingList && response && response.data) {
              loadFloorPlanSettingList(response);
            }
          } catch (error) {
            //console.error("Error processing floor plan data:", error);
            openModalAlert("Error processing floor plan data:" + error);
          }
          
          if (this.state.dateFilter.from && this.state.dateFilter.to && this.state.dateFilter.column) {
            setTimeout(() => {
              this.state.refTable.setFilter(this.filterByDate);
            }, 0);
          }
          
          // Return the data array from the response
          return response.data || [];
        },
        ajaxError: (error) => {
          console.error(this.tableId + ' ajaxError', error);
        }
      };
  
      return (
        <ReactTabulator
          ref={(ref) => (this.ref = ref)}
          columns={this.columns}
          data={[]}
          placeholder="No data found"
          options={options}
          className="custom-list-table"
          dataLoading={this.dataLoading}
          pageLoaded={this.pageLoaded}
        />
      );
    }
  
    pageLoaded = () => {
      const { refTable } = this.state;
      const { authToken ,accountOperationStatusList, saveAccountOperationStatus, saveAccountOperationStatusInFrontEnd } = this.props;
      console.log("aaa ", accountOperationStatusList);
  
      accountOperationStatusList[this.tableId]["pageSize"] = accountOperationStatusList[this.tableId]["pageSize"] ? refTable.modules.page.size : 10;
      saveAccountOperationStatusInFrontEnd(accountOperationStatusList);
      saveAccountOperationStatus(authToken ,this.tableId, accountOperationStatusList[this.tableId]);
      window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT_OPERATION_STATUS,JSON.stringify(accountOperationStatusList));
    }
  
    reloadList = (e) => {
      const { refTable } = this.state;
      if (refTable) {
        refTable.clearData();
        
        refTable.replaceData();
        
      }
    }
  
    reloadData = (account) => {
      const { refTable } = this.state;
      
      if (refTable) {
        // Update the request body if needed
        refTable.options.ajaxContentType.body = (url, config, params) => {
          return JSON.stringify({
            organizationId: orgFilter,
            limit: 100,
            offset: 0
            // Add any other parameters needed
          });
        };
        this.reloadList();
      }
    }
    
    componentDidMount() {
      const {selectSite} = this.props;
      orgFilter = selectSite;
  
      const session = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT_OPERATION_STATUS));
      const newPageSize = session && session[this.tableId] ? session[this.tableId]["pageSize"] : 10;
  
      this.setState({
        pageSize: newPageSize,
      });
      
      // We're not using doGetVisualData since we're fetching directly in the table
    }
  
    componentDidUpdate(prevProps, prevState, snapshot) {
      const { menuMode/*, tabulatorDivHeight*/, status, errMsg, modalPick, authToken, selectSite, doConfirmAccountApply, openModalAlert, loginStatus } = this.props;
      const { refTable } = this.state;
  
      if (refTable) {
        if (prevProps.menuMode !== menuMode) {
          // if menu chagne size(mode), need redraw table     
          refTable.redraw(true);
        }
  
        // if (typeof tabulatorDivHeight === 'number') {
        //   refTable.setHeight(tabulatorDivHeight);
        // }
  
        if (prevProps.menuMode !== status) {
          if (DELETE_SETTING_ACCOUNT_SUCCESS === status) {
            this.reloadData(null);
          } else if (DELETE_SETTING_ACCOUNT_FAIL === status && errMsg) {
            openModalAlert(errMsg);
          } else if (SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS === status) {
            this.reloadData(null);
          } else if (CONFIRM_SETTING_ACCOUNT_APPLY_SUCCESS === status) {
            this.reloadData(null);
          } else if (SAVE_SETTING_ROLE_DETAIL_SUCCESS === status) {
            this.reloadData(null);
          }
        }
        if(prevProps.selectSite !== selectSite){
          orgFilter = selectSite;
          this.dateFormatterParams.timezone = this.props.timeZoneID;
          this.reloadData(null);
        }
        if(prevProps.loginStatus !== loginStatus && loginStatus === "DO_CHANGE_NAME_SUCCESS"){
          this.reloadData(null);
        }
        // if(notifyItemData && prevProps.notifyItemData !== notifyItemData) {
        //   this.reloadData(notifyItemData.account);
        // }
      }
  
      if (prevProps.modalPick.modalMessage !== modalPick.modalMessage && modalPick.modalStatus === 'settingsAccountReadyAdd') {
        if (modalPick.modalMessage === MODAL_PICK_SAVE) {
          if (modalPick.modalResult !== undefined && modalPick.modalResult !== null) {
            const objForm = {
              organization: selectSite,
              applyList: modalPick.modalResult
            };
            doConfirmAccountApply(authToken, objForm);
          }
        }
      }
    }
  
    render() {
      const { visibleColumnsConfig } = this.state;
      const { openModalAlert } = this.props;

      return (
        <div className='account-setting-list'>
          <DateFilter onApply={this.handleDateFilter} componentName="FloorPlanSettingsList" openModalAlert={openModalAlert} />
          {/* <div className='area-header-btns'>
            <div className='area-add-btn' onClick={this.addRow}>
              <div className='area-icon'><span className='icon-btn-add-n'></span></div>
              <div className='area-text'>Add new floor plan</div>
            </div>
          </div>         */}
          <div className='area-custom-list'>
            <span className='area-setting-list-icon'>
              <ListColumnBtn 
                tableId={this.tableId}
                refTable={this.state.refTable} 
                refs={(ref) => {this.refTableToolBar = ref;}}
                visibleColumnsConfig={visibleColumnsConfig}>
              </ListColumnBtn>
            </span>
            {this.renderTable()}
          </div>
        </div>
      );
    };
  }
  
  const mapStateToProps = (state, ownProps) => {
    return {
      authToken: state.loginReducers.authToken,
      timeZoneID: state.loginReducers.timeZoneID,
      status: state.settingsReducers.status,
      errMsg: state.settingsReducers.errMsg,
      selectSite: state.siteReducers.selectSite,
      menuMode: state.menuReducers.displayMode,
      modalPick: state.commonReducers.modalPick,
      loginStatus: state.loginReducers.status,
      accountOperationStatusList: state.settingsReducers.accountOperationStatusList,

    }
  }
  
  export default withRouter(connect(
    mapStateToProps,
    {
      openModal,
      openPickModal,
      popupModalConfirm,
      doConfirmAccountApply,
      openModalAlert,
      loadFloorPlanSettingList,
      saveAccountOperationStatus ,
      saveAccountOperationStatusInFrontEnd
    }
  )(FloorPlanSettingsList))
  

